import PropTypes from 'prop-types'
import { TB } from './Default/index'

// Bordered Bottom Tabs
export const BBTabs = ({ tabs, ...props }) => {
  return (<TB type='line' tabs={tabs} {...props} />)
}

BBTabs.propTypes = {
  tabs: PropTypes.array.isRequired
}
// End Bordered Bottom Tabs
